import { render, staticRenderFns } from "./IconCheckedNoBorder.vue?vue&type=template&id=400af178&"
import script from "./IconCheckedNoBorder.vue?vue&type=script&lang=ts&"
export * from "./IconCheckedNoBorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports